/**
 * « Sans acompte » / « No Deposit Required » badge of transfer and private
 * driver cards. Shown only when the server says this listing's booking
 * deposit is 0 % (`booking_deposit_percentage`, the rule the booking applies:
 * backend/services/booking_deposit.py), never assumed from other fields.
 * Scooters and excursions never show it.
 */
export const NO_DEPOSIT_CATEGORIES = ['transfer', 'private_driver'];

export const hasNoDeposit = (service) => Boolean(service)
  && NO_DEPOSIT_CATEGORIES.includes(service.category)
  && service.booking_deposit_percentage === 0;

/** Deposit percentage asked after acceptance (> 0), else null. */
export const depositPercentage = (service) => {
  const pct = service && NO_DEPOSIT_CATEGORIES.includes(service.category) ? service.booking_deposit_percentage : null;
  return typeof pct === 'number' && pct > 0 ? pct : null;
};
